import { Box, VStack, Heading, Body, Container } from '@hover/blueprint';
import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

const AboutSectionsMobile: React.FC = () => (
  <Container px={200}>
    <VStack display={{ base: 'flex', desktop: 'none' }} spacing={900} mb={900}>
      <Box flexDir="column">
        <Box maxW="380px" maxH="560px" alignSelf="center" px={500} mb={500}>
          <StaticImage
            quality={100}
            placeholder="blurred"
            src="../../../assets/images/about_hover_design_tools_homeowner.png"
            alt="about hover design tools for homeowners"
            objectFit="contain"
          />
        </Box>
        <Heading mb={400} size={500}>
          Design Tools for Homeowners
        </Heading>
        <Body size={500} mb={500}>
          Select and see real products - roofing, siding, windows, and more - on
          a virtual 3D model of your home.
        </Body>
        <Body mb={500} size={500} isBold>
          Home improvement is a big deal - we take the guesswork out.
        </Body>
      </Box>
      <Box flexDir="column">
        <Box maxW="380px" maxH="380px" alignSelf="center" mb={500}>
          <StaticImage
            quality={100}
            placeholder="blurred"
            src="../../../assets/images/about_hover_productivity.png"
            alt="about hover collaboration"
            objectFit="contain"
          />
        </Box>
        <Heading mb={400} size={500}>
          Productivity Tools for Professionals
        </Heading>
        <Body size={500} mb={500}>
          Easier, more accurate measurements, automatic estimations, populated
          takeoffs, direct supplier ordering... all in one place.
        </Body>
        <Body mb={500} size={500} isBold>
          Get more done by working smarter, not harder.
        </Body>
      </Box>
      <Box flexDir="column">
        <Box maxW="380px" maxH="355px" alignSelf="center" mb={500}>
          <StaticImage
            quality={100}
            placeholder="blurred"
            src="../../../assets/images/about_hover_collaboration.png"
            alt="about hover collaboration"
            objectFit="contain"
          />
        </Box>
        <Heading mb={400} size={500}>
          Collaboration at Its Best
        </Heading>
        <Body size={500} mb={500}>
          Homeowners and pros can use our tools together -- virtually or in
          person -- to select materials, build estimates, and sign proposals.
        </Body>
        <Body mb={500} size={500} isBold>
          Transparent collaboration builds trust and results in an honest, fair
          deal for all.
        </Body>
      </Box>
    </VStack>
  </Container>
);

export default AboutSectionsMobile;
